
import { ConstituentLevelConversionData } from "@oldDashboard/legacyModels/constituentLevelConversionData.model";
import { CumulativeInvoice } from "@oldDashboard/legacyModels/cumulativeInvoice";
import { EngagementData } from "@oldDashboard/legacyModels/engagementData.model";
import { EngagementTeam } from "@oldDashboard/legacyModels/engagementTeam.model";
import { FileSummary } from "@oldDashboard/legacyModels/fileSummary.model";
import { GuidePost } from "@oldDashboard/legacyModels/guidePost.model";
import { LastTermDistribution } from "@oldDashboard/legacyModels/lastTermDistribution.model";
import { LaunchKeyDates } from "@oldDashboard/legacyModels/launchKeyDates.model";
import { Launches } from "@oldDashboard/legacyModels/launches.model";
import { LaunchesDate } from "@oldDashboard/legacyModels/launchesDate.model";
import { LeadingIndicator } from "@oldDashboard/legacyModels/leadingIndicador.model";
import { ListSizeOverTime } from "@oldDashboard/legacyModels/listSizeOverTime.model";
import { MotivationPrinciple } from "@oldDashboard/legacyModels/motivationPrinciple.model";
import { RecommendedAction } from "@oldDashboard/legacyModels/recommendedAction.model";
import { TimePeriods } from "@oldDashboard/legacyModels/timePeriods.model";
import { TotalGpSummary } from "@oldDashboard/legacyModels/totalGpSummary.model";
import  store  from '@oldDashboard/rootStore';

const { state } =  store.dashboardState;

export const setLaunchesAction = (value: Launches[]) => {
    state.launches = value;
};

export const selectLaunchAction = (value: string) => {
   state.launchSelected = value;
};

export const setTimePeriodsAction = (value: TimePeriods[]) => {
    state.timePeriods = value;
};

export const selectTimePeriodAction = (value: string) => {
    state.timePeriodSelected = value;
};

export const setConstituentsConversionsAction = (value: ConstituentLevelConversionData) => {
    state.constituentsConversions = value;
};

export const setFileSummaryDataAction = (value: FileSummary[]) => {
    state.fileSummaryData = value;
};

export const setLaunchDatesAction = (value: LaunchesDate[]) => {
    state.launchDates = value;
};

export const setTopGuidepostsAction = (value: GuidePost[]) => {
    state.topGuideposts = value;
};

export const setRunningGuidepostsAction = (value: GuidePost[]) => {
    state.runningIdeas = value;
};

export const setListSizeOverTimeAction = (value: ListSizeOverTime[]) => {
    state.listSizeOvertime = value;
};

export const seLastTimeDistributionAction = (value: LastTermDistribution) => {
    state.lastTermDistribution = value;
};

export const setTopPerformingNetworkAction = (value: []) => {
    state.topPerformingNetwork = value;
};

export const setUseListSizeAction = (value: string) => {
    state.totalStudents = value
};

export const setLaunchGoalAction = (value: string) => {
    state.launchGoal = value;
};

export const setRecommendedActions = (value: RecommendedAction) => {
    state.recommendedActions = value;
};

export const setConversionJourneys = (value: []) => {
    state.conversionJourneys = value;
};

export const searchDashboardClient = (value: boolean) => {
    state.searching = value;
};

export const setLaunchKeydatesAction = (value: LaunchKeyDates) => {
    state.launchKeydates = value;
};

export const setTotalGpSummaryAction = (value: TotalGpSummary) => {
    state.totalGpSummary = value;
};

export const setEngagementTeamAction = (value: EngagementTeam) => {
    state.engagementTeam = value;
};

export const setLeadingIndicatorsAction = (value: LeadingIndicator) => {
    state.leadersIndicators = value;
};

export const setRunningIdeasAction = (value: GuidePost[]) => {
    state.runningIdeas = value;
};

export const setScheduledIdeasAction = (value: GuidePost[]) => {
    state.scheduledIdeas = value;
};

export const setMotivationPrinciplesAction = (value: MotivationPrinciple[]) => {
    state.motivationPrinciples = value;
};

export const setEngagementDataAction = (value: EngagementData) => {
    state.engagementData = value;
};

export const setCumulativeInvoiceAction = (value: CumulativeInvoice) => {
    state.cumulativeInvoice = value;
};
